/* eslint-disable */
import axios from 'axios';
import { environment, token } from '@gaodun.com/gtools';
import { appId } from './config';
import { ICustomAxiosConfig, IResponse } from '@/sub-luca-plugin/types';
import { message as toast } from 'antd';
import { transformOptions } from '.';

const http = axios.create();

http.interceptors.request.use(
    config => {
        return Promise.resolve(config);
    },
    error => {
        return Promise.reject(error);
    }
);

http.interceptors.response.use(
    response => {
        // console.log('response', JSON.stringify(response));
        const { config, data } = response;
        const { needToastError } = config as any;
        const { status, info, message } = data;
        if (status !== 0 && needToastError) {
            toast.warning(message || info || '服务器错误');
        }
        if ((status > 553649000 && status < 563649999) || status === 10160001) {
            location.href = `https://${environment.getApiEnv()}v.gaodun.com`;
        }
        return Promise.resolve(response);
    },
    error => {
        return Promise.reject(error);
    }
);

class Http {
    baseUrl = environment.getApigateWay();
    async request<T>(options: ICustomAxiosConfig): Promise<IResponse<T>> {
        try {
            const newOptions = await transformOptions({...options, url: this.baseUrl + options.url});
            const { data } = await http.request<IResponse<T>>(newOptions);
            return data;
        } catch (error) {
            return { status: -1 } as any;
        }
    }
    get<T = any>(url: string, data?: any, customOptions?: ICustomAxiosConfig) {
        return this.request<T>({ url, method: 'GET', params: data, ...(customOptions || {}) });
    }
    post<T = any>(url: string, data?: any, customOptions?: ICustomAxiosConfig) {
        return this.request<T>({ url, method: 'POST', data, ...(customOptions || {}) });
    }
    delete<T = any>(url: string, data?: any, customOptions?: ICustomAxiosConfig) {
        return this.request<T>({ url, method: 'DELETE', data, ...(customOptions || {}) });
    }
    put<T = any>(url: string, data?: any, customOptions?: ICustomAxiosConfig) {
        return this.request<T>({ method: 'PUT', url, data, ...(customOptions || {}) });
    }
}

export default new Http();
